export default {
  processing: {
    en: 'processing order',
  },
  onTheWay: {
    en: 'on the way',
  },
  arrivesIn: {
    en: 'arrives in',
  },
  delivered: {
    en: 'delivered',
  },
}
